export const pivotOptions = [
    { headerText: 'Event types', itemKey: 'eventTypes' },
    { headerText: 'Events management', itemKey: 'eventsManagement' },
    { headerText: 'Events file upload', itemKey: 'eventsFileUpload' },
];
